export const KPI_ID = {
  ABO_NAME: "aboName",
  ENTRY_DATE: "entryDate",
  PERSONAL_PV: "personalPV",
  PERSONAL_PV_REQ: "personalPVRequirement",
  PERSONAL_PV_YTD: "personalPVYtd",
  GROUP_PV: "groupPV",
  GROUP_PV_NEEDED: "groupPVNeeded",
  CUSTOMER_PV: "customerPV",
  SPONSORING: "totalNewABOCount",
  SPONSORING_YTD: "newABOCountYtd",
  GROUP_SIZE: "totalABOCount",
  CUSTOMER_COUNT: "totalCustomerCount",
  AUTO_RENEWAL: "autoRenewal",
  SPONSOR_NAME: "sponsorName",
  VCS_PERCENT: "personalVcsPercent",
  FRONTLINES: "frontlines",
  IS_FIRST_CONTRACT_YEAR: "isFirstContractYear",
  BIRTHDATE: "birthDate",
  ANNUAL_PPV: "annualPPV",
  RENEWAL_DATE: "renewalDate",
  BONUS_PERCENT: "bonusPercent",
  RUBY_PV: "rubyPV",
  QUALIFIED_LEGS: "qualifiedLegs",
  GROUP_BV: "groupBV",
  POINTS_TO_NEXT_LEVEL: "pointsToNextLevel",
  PERSONAL_ORDERS: "personalOrders",
  GROUP_ORDERS: "groupOrders",
  VCS_PV: "vcsPV",
  NON_VCS_PV: "nonVCSPV",
  PERSONAL_ORDERS_COUNT: "personalOrdersCount",
  GROUP_ORDERS_COUNT: "groupOrdersCount",
  PERSONAL_PV_REQ_AR: "ppvARRequirement",
  NON_BONUSABLE_BV: "nonBonusableBV",
  CBR_PERIOD_REMAINING: "cbrPeriodRemaining",
  CBR_VCS_PERCENT: "cbrVcsPercent",
  CBR_START_MONTH: "cbrStartMonth",
  CBR_END_MONTH: "cbrEndMonth",
  SAQ_STATUS: "saqStatus",
  PHONE_NUMBER: "phoneNumber",
  WHATSAPP: "whatsapp",
  IMAGE_REF_URL: "imageRefURL",
};

export type KpiId = (typeof KPI_ID)[keyof typeof KPI_ID];

export interface AboEnrichmentRequest {
  affAbos: string[];
  bonusPeriod: string;
  locale: string;
  isoCountryCode: string;
  kpis: string[];
  customers?: string[];
}

interface ValueData {
  value: number;
  formatted: string;
}

interface CountryData {
  [countryCode: string]: ValueData;
}

interface VolumeData {
  code: string;
  byCountry: CountryData;
  total: ValueData;
}

interface PersonalPVRequirement {
  volume: VolumeData;
  target: ValueData;
}

interface CountData {
  value: number;
  formatted: string;
}

export interface AboKpiData {
  aff: string;
  abo: string;
  entryDate?: string;
  renewalDate?: string;
  aboName?: string;
  personalPV?: VolumeData;
  personalPVRequirement?: PersonalPVRequirement;
  ppvARRequirement?: PersonalPVRequirement;
  personalPVYtd?: VolumeData;
  groupPV?: VolumeData;
  groupPVNeeded?: ValueData;
  customerPV?: VolumeData;
  totalABOCount?: CountData;
  totalNewABOCount?: CountData;
  newABOCountYtd?: CountData;
  totalCustomerCount?: CountData;
  totalFrontlineCount?: CountData;
  sponsorName?: string;
  autoRenewal?: boolean;
  personalVcsPercent?: {
    value: number;
    formatted: string;
  };
  isFirstContractYear?: boolean;
  annualPPV?: CountData;
  bonusPercent?: CountData;
  qualifiedLegs?: CountData;
  groupBV?: VolumeData;
  rubyPV?: VolumeData;
  personalOrdersCount?: CountData;
  groupOrdersCount?: CountData;
  vcsPV?: VolumeData;
  nonVCSPV?: VolumeData;
  nonBonusableBV?: VolumeData;
  saqStatus?: boolean;
  phoneNumber?: string;
  whatsapp?: string;
  imageRefURL?: string;
}

interface CallResult {
  responseBody: string;
  url: string;
  error: string | null;
  status: number;
  duration: number;
}

export interface AboEnrichmentResponse {
  aboKpiData: AboKpiData[];
  callResults: CallResult[];
  timestamp: string;
}
